import * as React from 'react';
import * as moment from 'moment';

import { connect } from 'react-redux';

import ListProductionGroupView from '../../views/library/list-production-group.view';
import { IPackageListingAppState } from '../../redux-state';
import { IPackageListingAppText } from '../../custom/classes/package-listing-text';
import { IPerformanceGroup, IProduction, IPerformance } from '../../custom/classes/production';

interface IListProductionGroupExternalProps {
    performanceGroup: IPerformanceGroup;
}

interface StateToProps {
    text: IPackageListingAppText;
    performanceFilter: (prod: IProduction) => boolean;
    requiresPerformanceGroupMin: boolean;
    requiresPerformanceGroupMax: boolean;
    groupMin: number;
    groupMax: number;
    cartPerformanceIdsInGroup: Array<number>;
}

export type ListProductionGroupProps = IListProductionGroupExternalProps & StateToProps;

export class ListProductionGroupBase extends React.Component<ListProductionGroupProps, any> {
    render() {
        return (
            <ListProductionGroupView {...this.props} />
        )
    }
}

function mapStateToProps(state: IPackageListingAppState, ownProps: IListProductionGroupExternalProps): StateToProps {
    const groupPerfIds = ownProps.performanceGroup.tessPerformances.map(p => p.performanceId);
    return {
        text: state.packageListingText,
        performanceFilter: state.packageListing.filterFunction,
        requiresPerformanceGroupMin: state.packageListing.packageDetail.performanceGroupDetails.length > 1 && ownProps.performanceGroup.minimumPerformances > 0,
        requiresPerformanceGroupMax: state.packageListing.packageDetail.performanceGroupDetails.length > 1 && ownProps.performanceGroup.maximumPerformances > 0 && ownProps.performanceGroup.maximumPerformances !== state.packageListing.packageDetail.maximumPerformances,
        groupMin: ownProps.performanceGroup.minimumPerformances,
        groupMax: ownProps.performanceGroup.maximumPerformances,
        cartPerformanceIdsInGroup: Array.from(state.packageListing.cartItems.keys()).filter(p => groupPerfIds.indexOf(p) >= 0)
    }
}

export default connect<StateToProps>(mapStateToProps)(ListProductionGroupBase);